import _Object$keys from 'babel-runtime/core-js/object/keys';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _typeof from 'babel-runtime/helpers/typeof';
/**
 * @param {any} params
 * @param {Object<string, boolean>} [entries={}]
 * @returns {Object<string, boolean>}
 */
function _classEntries(params) {
  var entries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (params === null) {
    return entries;
  }

  if (Array.isArray(params)) {
    return params.reduce(function (acc, param) {
      return _classEntries(param, acc);
    }, entries);
  }

  var type = typeof params === 'undefined' ? 'undefined' : _typeof(params);

  if (type === 'object') {
    return _Object$entries(params).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          test = _ref2[1];

      if (test) {
        return _classEntries(name, acc);
      }

      return acc;
    }, entries);
  }

  if (type === 'string') {
    var param = params.trim();

    if (param === '') {
      return entries;
    }

    if (param.match(/\s+/)) {
      return _classEntries(param.split(/\s+/), entries);
    }

    return _extends({}, entries, _defineProperty({}, param, true));
  }

  return entries;
}

/**
 * @param {Array<any>} params
 * @returns {string|void}
 */
function classes() {
  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  var classSet = _Object$keys(_classEntries(params));
  return classSet.length ? classSet.join(' ') : undefined;
}

export default classes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/classes.js
// module id = 206
// module chunks = 0